import { PaymentsContextDto } from '../contexts/dtos/PaymentsContextDto';

export const paymentsReducer = (state: PaymentsContextDto, action: PaymentsReducerType) => {
  switch (action.type) {
    case PaymentsReducerActionOptions.Update:
      return { ...state, ...action.payments };
    case PaymentsReducerActionOptions.Reset:
      return new PaymentsContextDto();
    case PaymentsReducerActionOptions.SetTenantCurrentStep:
      return { ...state, tenant: { ...state.tenant, currentStep: action.payload } };
    case PaymentsReducerActionOptions.SetTenantShowedStep:
      return { ...state, tenant: { ...state.tenant, showedStep: action.payload } };
    default:
      return state;
  }
};

export class PaymentsReducerActionOptions {
  static Update = 'Update';
  static Reset = 'Reset';
  static SetTenantCurrentStep = 'SetTenantCurrentStep';
  static SetTenantShowedStep = 'SetTenantShowedStep';
}

export interface PaymentsReducerType {
  type: PaymentsReducerActionOptions;
  payments: PaymentsContextDto | null;
  payload?: any;
}
